import { render, staticRenderFns } from "./GruppoLavorazionePerStagioneTabella.vue?vue&type=template&id=8bf855f6&scoped=true"
import script from "./GruppoLavorazionePerStagioneTabella.vue?vue&type=script&lang=ts"
export * from "./GruppoLavorazionePerStagioneTabella.vue?vue&type=script&lang=ts"
import style0 from "./GruppoLavorazionePerStagioneTabella.vue?vue&type=style&index=0&id=8bf855f6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf855f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bf855f6')) {
      api.createRecord('8bf855f6', component.options)
    } else {
      api.reload('8bf855f6', component.options)
    }
    module.hot.accept("./GruppoLavorazionePerStagioneTabella.vue?vue&type=template&id=8bf855f6&scoped=true", function () {
      api.rerender('8bf855f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GruppoLavorazionePerStagioneTabella.vue"
export default component.exports